export const calculatePercentage = (totalNum: number) => {
  const previoustotalNum = 1000; 
  const percentageChange = ((totalNum - previoustotalNum) / previoustotalNum) * 100;
  return percentageChange.toFixed(2) + '%';
}